import type { FaireProductEntity } from "../../entity_types/product";

export const p_mw5bkhk9fh: FaireProductEntity = {
  token: "p_mw5bkhk9fh",
  type: "product",
  name: "Not Fluent In Gen Z Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/f404a008960f7f1674fd0b1bf64d6633b1c3561ce3fd9ffd360641982965aa6c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5534977fd1d21d63c111f72d85d38d06313e437a2cb3c499d11e437359b2da87.jpeg",
    "https://cdn.faire.com/fastly/e2ece67f4f98983da5e8b5308348b0abfc4d35c893b9e1949060e8dc78957bdd.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/7296550aeea88ad9fe292bd254b3f3d673ec2fc33b798bdd439a28e1499463ea.jpeg",
    "https://cdn.faire.com/fastly/d8ca4b82a190b423c5a95248c40f93099344687ebba3ea201a034fb1b1a0fc79.jpeg",
    "https://cdn.faire.com/fastly/b25d0301a446e4aa0c68b68109e2aad538ebe26403138e0f780d3e66644561a0.jpeg",
    "https://cdn.faire.com/fastly/9dc6653e97b93aeb360de18a80410d36934d2f5fd23a27c550825fcfebab47bb.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks announce to the world that you’re very online but also very confused. TL;DR we're cooked, chat.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:22.314Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
